import { Dialog, DialogContent, DialogTitle } from "@nexus/ui"

export interface KeyboardShortcutItem {
  keys: string[]
  label: string
}

export interface KeyboardShortcutsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  shortcuts: KeyboardShortcutItem[]
}

export function KeyboardShortcutsDialog({
  open,
  onOpenChange,
  title,
  shortcuts,
}: KeyboardShortcutsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md gap-0 p-0">
        <div className="border-b border-border/60 px-5 py-3">
          <DialogTitle className="text-sm font-semibold">{title}</DialogTitle>
        </div>
        <ul className="divide-y divide-border/40">
          {shortcuts.map((s) => (
            <li key={s.label} className="flex items-center justify-between gap-3 px-5 py-2.5">
              <span className="text-sm text-foreground">{s.label}</span>
              <span className="flex shrink-0 items-center gap-1">
                {s.keys.map((k) => (
                  <kbd
                    key={k}
                    className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground"
                  >
                    {k}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
